import Page from './Page';
import reducer from './reducer';

export const reducers = { CategoryManager: reducer };
export default { Page, reducers };